import { createFileRoute } from "@tanstack/react-router";
import SeoLocal from "../../pages/soluciones/SeoLocal";

export const Route = createFileRoute("/que-hacemos/seo-local")({
  component: SeoLocal,
});
